module.exports = __webpack_public_path__ + "static/media/Atzelsdorf.bcad92d4.webp";